module.exports = __webpack_public_path__ + "images/stickers/laugh.31ce444242a6f930b521.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/laugh.png
// module id = 06HP
// module chunks = 2